import { useTranslation } from 'react-i18next'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { api } from '../../utils/api'
import { ContentType } from '../../utils/api/tools'
import { GET_RELATIVE_SCG, useCreateUserClaim, useGetEClaimById, useGetEClaimListScg } from '../e-claim/e-claim-query'
import { E_CLAIM_LIST, E_CLAIM_BY_ID } from '../e-claim/e-claim-query'
import { InsuranceHistoryListResponse, InsuranceListResponse } from './insurance-types'

const APP = '/app'
export const USER_CLAIM = 'userClaim'
export const INSURANCE_HISTORY_LIST = `${APP}/${USER_CLAIM}/getAllUserClaimByUser`

// export const useGetExerciseById = (props: GetEClaimByIdProps) => {
//   const { claimId } = props

//   return useQuery([E_CLAIM_BY_ID, claimId], () => {
//     return api.belive.get<EClaimItem>(`${E_CLAIM_BY_ID}/${claimId}`)
//   })
// }
export const useGetInsuranceById = useGetEClaimById

export const useGetInsuranceList = (groupName = 'insurance') => {
  return useQuery<InsuranceListResponse>([E_CLAIM_LIST, groupName], () => {
    return api.belive.get<InsuranceListResponse>(`${E_CLAIM_LIST}?claimTypeGroupName=${groupName}`)
  })
}

export const useCreateInsuranceClaim = useCreateUserClaim

export const useGetInsuranceHistoryList = (groupCode = 'insurance') => {
  return useQuery([INSURANCE_HISTORY_LIST, groupCode], () => {
    return api.belive.get<InsuranceHistoryListResponse>(`${INSURANCE_HISTORY_LIST}?claimTypeGroupCode=${groupCode}`)
  })
}

// export const useGetRelativeOption = (claimId?: number) => {
//   return useQuery([GET_RELATIVE_SCG, 'options', claimId], async () => {
//     const data = await api.belive.get<RelativeScgResponse>(`${GET_RELATIVE_SCG}/opd/${claimId}`)
//     const optionRelative: {
//       label: string
//       value: Record<string, string>
//       disabled?: boolean
//     }[] = []

//     data.map((relative) => {
//       const { firstname, lastname, id, typeId, typeName } = relative
//       optionRelative.push({
//         label: `${typeName}: ${firstname} ${lastname}`, value: {
//           id: id.toString(),
//           typeId: typeId.toString(),
//         }
//       })
//     })
//     // }

//     return optionRelative
//   })
// }